export const ROLE_RANK = { rig: 1, supervisor: 2, admin: 3, owner: 4 };
export const ROLE_OPTIONS = [
  { value: "rig", label: "Rig" },
  { value: "supervisor", label: "Supervisor" },
  { value: "admin", label: "Admin" },
  { value: "owner", label: "Owner" },
];
export const roleRank = (role) => ROLE_RANK[String(role || "rig").toLowerCase()] || 0;
export const isAtLeast = (role, minimum) => roleRank(role) >= roleRank(minimum);
export const isAdminOrOwner = (role) => isAtLeast(role, "admin");
